<!-- =========================================================================================
    File Name: ItemListView.vue
    Description: Item Component - List VIew
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <vx-card class="list-view-item overflow-hidden" v-on="$listeners">

    <template slot="no-body">
      <div class="vx-row item-details no-gutter">

        <!-- IMG COL -->
        <div class="vx-col sm:w-1/4 w-full item-img-container bg-white flex items-center justify-center cursor-pointer"
          @click="navigate_to_detail_view"
          style="max-width: 200px;"
          >
          <img :src="item.url" :alt="item.owner" class="grid-view-img">
        </div>

        <!-- ITEM NAME & DESC COL -->
        <div class="vx-col sm:w-1/2 m-auto">

          <div class="item-details px-4 flex">

            <!-- LOGO & STATE -->
            <div>
              <img :src="`https://selfie.cash/avatar/${item.owner.avatar}`" :alt="item.owner" class="w-16 h-16 rounded-full">
              <vs-button v-if="item.status == `Pending`" class="mt-2 p-1 text-sm" color="warning" type="border">pending</vs-button>
              <vs-button v-if="item.status == `Approved`" class="mt-2 p-1 text-sm" color="primary" type="border">active</vs-button>
              <vx-tooltip :text='item.statusComment' position="right" color="danger">
                <vs-button v-if="item.status == `Rejected`" class="mt-2 p-1 text-sm" color="danger"
                  type="border">rejected</vs-button>
              </vx-tooltip>
            </div>
            <!-- TITLE & DESCRIPTION -->
            <div class="my-4 mx-8">
              <h6 class="truncate font-semibold mb-1 hover:text-primary cursor-pointer"
                @click="navigate_to_detail_view">{{ item.title }}</h6>
              <p class="item-description truncate text-sm">{{ item.owner.firstname + ' ' + item.owner.lastname }}</p>
            </div>
          </div>
        </div>

        <!-- PURCHASE COL -->
        <div
          class="vx-col sm:w-1/4 w-full flex items-center sm:border border-0 border-solid d-theme-border-grey-light border-r-0 border-t-0 border-b-0">

          <div class="p-4 flex flex-col w-full">

            <!-- SLOT: ACTION BUTTONS -->
            <slot name="action-buttons" />
          </div>
        </div>
      </div>
    </template>

  </vx-card>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    isInCart() {
      return (itemId) => this.$store.getters['eCommerce/isInCart'](itemId)
    },
    isInWishList() {
      return (itemId) => this.$store.getters['eCommerce/isInWishList'](itemId)
    }
  },
  methods: {
    toggleItemInWishList(item) {
      this.$store.dispatch('eCommerce/toggleItemInWishList', item)
    },
    additemInCart(item) {
      this.$store.dispatch('eCommerce/additemInCart', item)
    },
    cartButtonClicked(item) {
      this.isInCart(item.objectID) ? this.$router.push('/apps/eCommerce/checkout').catch(() => { }) : this.additemInCart(item)
    },
    navigate_to_detail_view() {
      this.$router.push({ name: 'ecommerce-item-detail-view', params: { item_id: this.item.objectID } })
        .catch(() => { })
    }
  }
}
</script>

<style lang="scss" scoped>
.list-view-item {

  .item-name,
  .item-description {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .item-name {
    -webkit-line-clamp: 2;
  }

  .item-description {
    -webkit-line-clamp: 5;
  }

  .grid-view-img {
    max-width: 100%;
    max-height: 100%;
    width: auto;
    transition: .35s;
  }

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0px 4px 25px 0px rgba(0, 0, 0, .25);

    .grid-view-img {
      opacity: 0.9;
    }
  }
}
</style>
